import {Pipe, PipeTransform} from '@angular/core';
import {Money} from '../../core/model/money';

@Pipe({name: 'price'})
export class PricePipe implements PipeTransform {
  transform(price: Money, currency: string = '€'): string {
    return `${price.amount / 100} ${currency}`;
  }
}

@Pipe({name: 'decimalPricePipe'})
export class DecimalPricePipe implements PipeTransform {
  transform(amount: number, currency: string = '€'): string {
    const price = Math.round(amount) / 100,
      formattedPrice = price.toFixed(2);

    return `${ formattedPrice } ${currency}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/price.pipe.ts